import { Component, Input, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';

@Component({
  selector: 'app-terminal',
  templateUrl: './terminal.component.html',
  styleUrls: ['./terminal.component.scss']
})
export class TerminalComponent implements AfterViewChecked {
  @Input() text: string = '';
  @Input() title: string = 'Terminal';
  @Input() height: string = '400px'; 

  @ViewChild('terminalBody') private terminalBodyKey!: ElementRef;

  // Se dispara cada vez que Angular pinta un cambio en la vista (ideal para streaming)
  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  private scrollToBottom(): void {
    try {
      if (this.terminalBodyKey && this.terminalBodyKey.nativeElement) {
        const el = this.terminalBodyKey.nativeElement;
        el.scrollTop = el.scrollHeight;
      }
    } catch (err) { }
  }

  // Formateador en tiempo real
  get formattedText(): string {
    if (!this.text) return '';

    const lines = this.text.split('\n');
    const processedLines: string[] = [];

    for (let line of lines) {
      // 1. Calculamos la profundidad según la indentación original (2 espacios = 1 nivel)
      const match = line.match(/^( +)/);
      const spaceCount = match ? match[1].length : 0;
      const depth = spaceCount > 0 ? Math.floor(spaceCount / 2) : 0;
      const blank = ' '.repeat(depth);
      // const prefix = '>_'.repeat(depth);
      const prefix = 'ESTIMATIA:: >> '+blank;

      // 2. Limpiamos la sintaxis JSON
      let cleanLine = line.replace(/[{}[\]",]/g, '').trim();

      // 3. Control de líneas vacías
      if (cleanLine === '') {
        // Si la línea original era un cierre de bloque "}", dejamos el prefijo para crear tu línea en blanco
        if (line.includes('}')) {
          processedLines.push(prefix);
        }
        continue;
      }

      // 4. Quitamos los dos puntos al final de las claves JSON
      if (cleanLine.endsWith(':')) {
        cleanLine = cleanLine.slice(0, -1);
      }

      processedLines.push(prefix + cleanLine);
    }

    return processedLines.join('\n');
  }
}